'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChatMessageData } from '../../_utils/message';
interface UserMessageProps {
  message: ChatMessageData;
}
export const UserMessage = t0 => {
  const $ = _c(2);
  const {
    message
  } = t0;
  let t1;
  if ($[0] !== message.content) {
    t1 = <div className="max-w-2xl rounded-xlarge bg-Gray-100 px-16 py-12 text-Gray-900 mobile-tablet:max-w-full"><p className="whitespace-pre-wrap break-words text-left font-500 text-Gray-900 typo-body3 mobile-tablet:typo-body4">{message.content}</p></div>;
    $[0] = message.content;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};